import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import { Plugin } from './plugin'

/**
 * {@link plugin.Plugin.Factory} for this {@link Plugin}
 * ({@link plugin.Plugin.Id.Standard.QueryPlugin})
 */
export class Factory<TTypeParams extends ec.models.TypeParams>
  implements
    ec.plugins.Plugin.Factory<
      TTypeParams,
      typeof Plugin.id,
      Plugin<TTypeParams>
    >
{
  public readonly id = Plugin.id

  constructor(
    private readonly _options:
      | Readonly<Factory.constructor.Params<TTypeParams>>
      | ((
          collection: ec.Collection<TTypeParams>,
        ) => Readonly<Factory.constructor.Params<TTypeParams>>) = {},
  ) {}

  public produceFor(
    collection: ec.Collection<TTypeParams>,
  ): Plugin<TTypeParams> {
    return new Plugin<TTypeParams>({
      ...(typeof this._options === 'function'
        ? this._options(collection)
        : this._options),
      collection,
    })
  }
}
export namespace Factory {
  export namespace constructor {
    export type Params<TTypeParams extends ec.models.TypeParams> = Omit<
      Plugin.constructor.Params<TTypeParams>,
      'collection'
    >
  }
}
